import { ImageScaleView } from '@play-co/timestep-core/ui';
import sounds from 'src/lib/sounds';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleView, {
  ButtonScaleViewOpts,
} from 'src/lib/ui/components/ButtonScaleView';
import { openGemsShopSequence } from '../shop/Helpers';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import bitmapFonts from 'src/lib/bitmapFonts';
import { getDisplayedGems } from '../inventory/inventory.util';
import { createEmitter } from 'src/lib/Emitter';
import { parseAmount } from 'src/lib/utils';
import Animator from 'src/lib/Animator';
import appConfig from '../minigame/match2-timestep/defs/appConfig';

export class GemsWallet extends ButtonScaleView {
  constructor(opts: ButtonScaleViewOpts) {
    super({
      ...opts,
      ...uiConfig.hud.coinLayout,
      onClick: async () => {
        sounds.sfx.play('ok');
        await openGemsShopSequence('gem_plus_button');
      },
      scale: 1.4,
    });

    new ImageScaleView({
      superview: this,
      ...uiConfig.hud.gemFrame,
    });

    new ImageScaleView({
      superview: this,
      ...uiConfig.hud.gemIcon,
    });

    const gemsText = new LangBitmapFontTextView({
      superview: this,
      font: bitmapFonts(uiConfig.hud.gemText.fontName),
      ...uiConfig.hud.gemText,
    });

    new ImageScaleView({
      superview: this,
      ...uiConfig.hud.gemPlus,
    });

    const gemsAnimator = new Animator((value) => {
      gemsText.localeText = () => parseAmount(value);
    }, getDisplayedGems());

    createEmitter(this, () => getDisplayedGems()).addListener((gems) => {
      gemsAnimator.setTarget(gems);
    });

    createEmitter(this, ({ ui }) => ui.screenSize).addListener((screen) => {
      const paddingRight = 100;
      const paddingTop = 20;

      this.updateOpts({
        x: appConfig.size.width - this.style.width - paddingRight,
        y: (appConfig.size.height - screen.height) / 2 + paddingTop,
      });
    });
  }
}
